export default "__VITE_PUBLIC_ASSET__67f925f0__"